import { Box, Button, Grid } from '@mui/material';
import { createContext, useEffect, useState } from 'react';
import { ItemServices } from './ItemServices';
import Swal from 'sweetalert2';
import SectionItemList from './SectionItemList';
import ItemReorder from './ItemReorder';
import Loading from '../../../../components/Loader/Loading';
import { useParams } from 'react-router-dom';
import SectionTabs from './SectionTabs';
import MobilePreview from '../Section/MobilePreview';
import { PhoneAndroid } from '@mui/icons-material';

export const ItemContext = createContext();

const SectionItems = () => {
    const { sectionId } = useParams();
    const [allRowCount, setAllRowCount] = useState(0);
    const [list, setList] = useState([]);
    const [selectedSection, setSelectedSection] = useState(null);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
        filters: {
            searchKey: "",
            sortBy: 'position',
            sortType: 'ASC',
            filterOptions: []
        }
    });
    const [loading, setLoading] = useState(false);

    // const fetchSectionData = async () => {
    //     if (!sectionId) return;
    //     try {
    //         const response = await ItemServices.getSectionById(sectionId);
    //         if (response.success == '1') {
    //             setSectionData(response.data);
    //         }
    //     } catch (error) {
    //         console.error("Failed to fetch section data:", error);
    //     }
    // };

    const fetchItemList = async () => {
        // if (!sectionId) return;
        try {
            setLoading(true);
            const listResponse = await ItemServices.itemList({
                page: paginationModel.page,
                limit: paginationModel.pageSize,
                sectionId: selectedSection?.id ,
                filters: {
                    searchKey: paginationModel.filters.searchKey,
                    sortBy: paginationModel.filters.sortBy,
                    sortType: paginationModel.filters.sortType,
                    filterOptions: paginationModel.filters.filterOptions || []
                }
            });
            if (listResponse.success == '1') {
                setList(listResponse.data.list);
                setAllRowCount(listResponse.data.totalItems);
            }
        } catch (error) {
            Swal.fire(error.message, '', 'error');
        }
        setLoading(false);
    };

    // useEffect(() => {
    //     fetchSectionData();
    // }, [sectionId]);

    useEffect(() => {
        if (selectedSection) {
            fetchItemList();
        }
    }, [paginationModel, selectedSection]);

    const handleStatusChange = async (data, itemId) => {
        const result = await Swal.fire({
            text: "Do you want to Change Item Status now?",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Change now!',
            cancelButtonText: 'No, Cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showCloseButton: false,
        });

        if (result.isConfirmed) {
            try {
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we update the item status',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const statusChangeResponse = await ItemServices.toggleStatus(itemId);

                if (statusChangeResponse.success == '1') {
                    await fetchItemList();
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: statusChangeResponse.message || 'Item Status updated successfully',
                        timer: 1500
                    });
                    return true;
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: statusChangeResponse.message || 'Failed to update item status'
                    });
                    return false;
                }
            } catch (error) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'An error occurred while updating the item status'
                });
                return false;
            }
        } else {
            return false;
        }
    };

    const handleDeleteItem = async (itemId) => {
        const result = await Swal.fire({
            text: "Are you sure you want to delete this item?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'Cancel',
            allowOutsideClick: false,
            allowEscapeKey: false,
        });

        if (result.isConfirmed) {
            try {
                Swal.fire({
                    title: 'Processing...',
                    text: 'Please wait while we delete the item',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });

                const deleteResponse = await ItemServices.deleteItem(itemId);

                if (deleteResponse.success == '1') {
                    await fetchItemList();
                    await Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: deleteResponse.message || 'Item deleted successfully',
                        timer: 1500
                    });
                    return true;
                } else {
                    await Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: deleteResponse.message || 'Failed to delete item'
                    });
                    return false;
                }
            } catch (error) {
                await Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: 'An error occurred while deleting the item'
                });
                return false;
            }
        }
        return false;
    };

    const handlePaginationChange = (newPagination) => {
        setPaginationModel({
            ...paginationModel,
            page: newPagination.page,
            pageSize: newPagination.pageSize
        });
    };

    const [sortModel, setSortModel] = useState([
        {
            field: paginationModel.filters.sortBy,
            sort: paginationModel.filters.sortType?.toLowerCase(),
        },
    ]);

    const handleSortingChange = (newSortModel) => {
        if (newSortModel && newSortModel.length > 0) {
            setSortModel(newSortModel);
            setPaginationModel(prev => ({
                ...prev,
                filters: {
                    ...prev.filters,
                    sortBy: newSortModel[0].field,
                    sortType: newSortModel[0].sort?.toUpperCase()
                }
            }));
        }
    };

    return (
        <ItemContext.Provider value={{
            list,
            setList,
            fetchItemList,
            loading,
            setLoading,
            allRowCount,
            paginationModel,
            handlePaginationChange,
            handleSortingChange,
            sortModel,
            handleStatusChange,
            handleDeleteItem,
            sectionId,
            // sectionData
        }}>
            {/* {loading && <Loading />} */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1 }}>
                <Button
                    variant="outlined"
                    startIcon={<PhoneAndroid />}
                    onClick={() => setPreviewOpen(true)}
                    size="small"
                    sx={{
                        borderColor: '#7c3aed', color: '#7c3aed',
                        '&:hover': { borderColor: '#5856d6', backgroundColor: 'rgba(88,86,214,0.05)' },
                        textTransform: 'none', fontWeight: 600, borderRadius: 2,
                    }}
                >
                    Preview App
                </Button>
            </Box>
            <Grid container spacing={1}>
                <Grid item xs={12} sm={2.5}>
                    <SectionTabs selectedSection={selectedSection} setSelectedSection={setSelectedSection} />
                </Grid>
                <Grid item xs={12} sm={7}>
                    <SectionItemList />
                </Grid>
                <Grid item xs={12} lg={2.5}>
                    <ItemReorder />
                </Grid>
            </Grid>
            <MobilePreview
                open={previewOpen}
                onClose={() => setPreviewOpen(false)}
                sectionId={selectedSection?.id || null}
                formData={null}
            />
        </ItemContext.Provider>
    );
};

export default SectionItems;
